/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://cihost.uberflip.com/mdfinancial-multi-tv2/a11y/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 153);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var streamEmbedCSS = __webpack_require__(1);

var displayTileHTML = function displayTileHTML(readTimeTranslation, tile, readVal) {
  var tileTitle = tile.querySelector('.uf-tile-title');

  var span = document.createElement('span');
  span.setAttribute('class', 'read-time-tile');
  span.textContent = readTimeTranslation.replace('[time]', readVal);
  tileTitle.insertAdjacentElement('beforebegin', span);
};

var tileReadTime = function tileReadTime(readTimeTranslation) {
  var elemTiles = [].concat(_toConsumableArray(document.querySelectorAll('.uf-tile-wrapper')));
  var tagSearch = 'read-time';

  elemTiles.forEach(function (tile) {
    if (tile.hasAttribute('data-tags') && !tile.querySelector('.read-time-tile')) {
      var dataTagsString = tile.dataset.tags.toLowerCase();
      var regex = new RegExp(tagSearch, 'gi');

      if (dataTagsString.match(regex)) {
        var array = dataTagsString.split(',');
        var readTag = array.filter(function (item) {
          return item.match(regex);
        }).toString();

        var readVal = readTag.split('-').filter(function (item) {
          return !isNaN(item) ? item : '';
        }).toString();

        readVal !== '' ? displayTileHTML(readTimeTranslation, tile, readVal) : null;
      }
    }
  });
};
// loadTiles from handleTile partial
var loadTiles = function loadTiles(lang) {
  var tiles = [].concat(_toConsumableArray(document.querySelectorAll('.uf-tile-wrapper')));
  var readTime;
  lang === 'en' ? readTime = 'Read time: [time] min' : readTime = 'Temps de lire: [time] minutes';

  for (var i = 0; i < tiles.length; i++) {
    tileReadTime(readTime);
  }
};

window._ufHubConfig.forEach(function (item) {
  var streamId = item.collection;
  document.addEventListener('uberflip.initalEmbedTilesLoaded-' + streamId, function (e) {
    // For English read time tags, set the parameter to 'en'
    // For French read time tags, set the parameter to 'fr'
    loadTiles('fr');
  });
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// fr/streamEmbed.bundle.js